// extracted by mini-css-extract-plugin
export default {"dataItem":"DataItem_dataItem__NC4nD","title":"DataItem_title__C17X1","value":"DataItem_value__7+RtL"};